import HttpService from "../baseHttp";

// 渠道产品列表
export const HttpGetChannelList = (data = {}, config) => HttpService.get('/api/v1/ProductChannel/findByPage', { params: data })

// 批量删除
export const HttpBatchDelete = (data = {}, config) => HttpService.post('/api/v1/ProductChannel/batchDelete', data)

// 批量激活/停用
export const HttpBatchActivation = (data = {}, config) => HttpService.post('/api/v1/ProductChannel/batchActivation', data)

// 批量上下架
export const HttpBatchSetSaleStatus = (data = {}, config) => HttpService.post('/api/v1/ProductChannel/batchSetSaleStatus', data)

// 调价
export const HttpChangePrice = (data = {}, config) => HttpService.post('/api/v1/ProductChannel/changePrice', data, { headers: { "Content-Type": "application/json" }, params: { contextId: global.SYSID } })

export const HttpPushStock = (data = {}, config) => HttpService.post('/api/v1/ProductChannel/pushStock', data)


//单条查看
export const HttpGetChannelOne = (data = {}, config) => HttpService.get('/api/v1/ProductChannel/findById', { params: data })

// 单条编辑/创建
export const HttpSaveChannelOne = (data = {}, config) => HttpService.post('/api/v1/ProductChannel/save', data, { headers: { "Content-Type": "application/json" }, params: { contextId: global.SYSID } })

// 编辑erpsku
export const HttpSaveErpsku = (data = {}, config) => HttpService.post('/api/v1/ProductChannel/changeErpsku', data, { headers: { "Content-Type": "application/json" }, params: { contextId: global.SYSID } })

// 编辑VC price
export const HttpChangeVcPrice = (data = {}, config) => HttpService.post('/api/v1/ProductChannel/changeVcPrice', data, { headers: { "Content-Type": "application/json" }, params: { contextId: global.SYSID } })

// 同步asin
export const HttpSyncAsin = (data = {}, config) => HttpService.post('/api/v1/ProductChannel/asynAsin', data, {})

// 根据模板id获取对应模板信息
export const HttpGetTemplated = (data = {}, config) => HttpService.get('/api/v2/AmazonTemplate/getById', { params: data })


// sfp添加
export const HttpSaveChannelProperty = (data = {}, config) => HttpService.post('/api/v1/ProductChannel/saveProperty', data, { headers: { "Content-Type": "application/json" }, params: { contextId: global.SYSID } })


// 渠道sfp产品列表
export const HttpGetChannelSFPList = (data = {}, config) => HttpService.get('/api/v1/ProductChannel/findPropertyByPage', { params: data })

// 批量SFP移除
export const HttpBatchSFPDelete = (data = {}, config) => HttpService.post('/api/v1/ProductChannel/deleteProperty', data)

//  验证推送比例百分比
export const HttpValidPushPercent = (data = {}) => HttpService.get('/api/v1/ProductChannel/getProportion', {params:data, baseURL: process.env.VUE_APP_APIURL_BOSS})


// 仓库SKU列表、查看、编辑、批量删除
export const HttpGetWarehouseSkuList = (data = {}) => HttpService.get('/api/v2/OrgWarehouseSku/findByPage', {params:data, baseURL: process.env.VUE_APP_APIURL_BOSS})

export const HttpGetWarehouseSkuOne = (data = {}) => HttpService.get('/api/v2/OrgWarehouseSku/findById', {params:data, baseURL: process.env.VUE_APP_APIURL_BOSS})

export const HttpSaveWarehouseSkuOne = (data = {}, config) => HttpService.post('/api/v2/OrgWarehouseSku/save', data, { headers: { "Content-Type": "application/json" }, params: { contextId: global.SYSID } })

export const HttpDeleteWarehouseSkuOne = (data = {}) => HttpService.get('/api/v2/OrgWarehouseSku/delete', {params:data, baseURL: process.env.VUE_APP_APIURL_BOSS})

// 批量获取自定义产品编码
export const HttpGetCodeByLineId = (data = {}) => HttpService.get('/api/v1/Product/findAllByProductIds', { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS })

// 操作历史
export const HttpSysOpLog = (data = {}) => HttpService.get("/api/v1/SysOpLog/findByPage", { params: data });
